module.exports = __webpack_public_path__ + "static/media/menubckg-mobile.2cdad078.png";